import { Tooltip } from "@mui/material";
import SiteIcons from "@/components/SiteIcons/SiteIcons";

export const getDashboardIcon = (file, column, callback = null) => {
  const confirmed = file.confirmed;
  const catalistOnly = file.use === "catalist-only";
  const confirmable = file.allow_confirm;

  if (column === "validation") {
    // this column always returns an icon
    if (catalistOnly) {
      if (confirmed) {
        return <SiteIcons iconstring="check" color="gold" onClick={callback} />;
      } else if (!confirmed) {
        return (
          <SiteIcons
            iconstring="checkoutline"
            color="gold"
            onClick={callback}
          />
        );
      }
    } else {
      if (confirmed) {
        return <SiteIcons iconstring="check" color="blue" onClick={callback} />;
      } else if (!confirmed && confirmable) {
        return (
          <SiteIcons
            iconstring="checkoutline"
            color="blue"
            onClick={callback}
          />
        );
      } else if (!confirmable) {
        return <SiteIcons iconstring="error" color="red" onClick={callback} />;
      } else {
        // this should never happen, but just in case
        console.error("This file doesn't have a validation icon: ", file);
        return null;
      }
    }
  }

  if (column === "catalist") {
    if (catalistOnly && file.catalist?.started && !file.catalist?.completed) {
      return <SiteIcons iconstring="pending" color="gold" />;
    } else if (catalistOnly && file.catalist?.completed) {
      return <SiteIcons iconstring="check" color="gold" onClick={callback} />;
    } else if (
      !catalistOnly &&
      file.catalist?.started &&
      !file.catalist?.completed
    ) {
      return <SiteIcons iconstring="pending" color="blue" />;
    } else if (!catalistOnly && file.catalist?.completed) {
      return <SiteIcons iconstring="check" color="blue" onClick={callback} />;
    } else if (!catalistOnly && file.catalist === "excluded") {
      return (
        <Tooltip title="Data intentionally excluded from catalist">
          <SiteIcons iconstring="excluded" color="blue" onClick={callback} />
        </Tooltip>
      );
    } else {
      return null;
    }
  }

  if (column === "VAN") {
    if (catalistOnly) {
      return (
        <Tooltip title="Catalist only files will never be sent to VAN">
          <SiteIcons iconstring="excluded" color="gold" onClick={callback} />
        </Tooltip>
      );
    } else if (!catalistOnly && file.catalist?.completed && !file.VAN?.posted) {
      return <SiteIcons iconstring="pending" color="blue" />;
    } else if (!catalistOnly && file.VAN?.posted) {
      return <SiteIcons iconstring="check" color="blue" onClick={callback} />;
    } else if (!catalistOnly && file.VAN === "excluded") {
      return (
        <Tooltip title="Data intentionally excluded from VAN">
          <SiteIcons iconstring="excluded" color="blue" onClick={callback} />
        </Tooltip>
      );
    } else if (file.VAN === "unstaged") {
      return (
        <Tooltip title="This file has been unstaged from VAN">
          <SiteIcons iconstring="excluded" color="blue" onClick={callback} />
        </Tooltip>
      );
    } else return null;
  }
};
